/** Absent / unknown → packaging (legacy rows, request 0283). */
export function effectiveProductUnitKind(unit) {
    return unit?.kind === 'measure' ? 'measure' : 'packaging';
}
export function isProductUnitPackaging(unit) {
    return effectiveProductUnitKind(unit) === 'packaging';
}
export function isProductUnitMeasure(unit) {
    return effectiveProductUnitKind(unit) === 'measure';
}
/** Derived factor only applies to measure lines with `isDerived === true`. */
export function isProductUnitDerived(unit) {
    return isProductUnitMeasure(unit) && unit?.isDerived === true;
}
//# sourceMappingURL=productUnitKind.js.map